module.exports = __webpack_public_path__ + "img/legalStatementBack.3b2a3a11.jpg";